/**
 * Created by roman.kupin on 10/3/2017.
 */

import PropertyApiActions from "../../../../../actions/propertyApi";

export const PREFIX = "[BigPicture]";
export const INITIALIZED = `${PREFIX}.Initialized`;
export const DATE_RANGE_CHANGE = `${PREFIX}.DateRangeChange`;


export function initialized(value) {
    return dispatch => {
        dispatch({ type: INITIALIZED, payload: value });
    }
}


export function fetchAdvocacyOverview(startDate, endDate) {
    return (dispatch, getState, { SpacesService }) => {
        return new Promise((resolve, reject) => {
            dispatch(PropertyApiActions.getAdvocacyOverview(SpacesService.getPropertyUuid(), startDate, endDate))
                .then(resolve, reject)
        });


    };
}

const All = { initialized, fetchAdvocacyOverview };
export default All;